export default "__VITE_ASSET__f713947c__"